var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Extract the root URL (origin) from a full URL
 * @param url - The full URL to extract the root from
 * @returns The root URL (protocol + domain + port)
 */
const getRootUrl = (url) => {
    try {
        const urlObj = new URL(url);
        return urlObj.origin;
    }
    catch (error) {
        // Fallback: if URL parsing fails, return the url as-is
        console.warn('Failed to parse URL for root extraction:', url, error);
        return url;
    }
};
/**
 * Prepares the streaming request options for sending a chat message
 * @param message - The user's message
 * @param auth - The authentication info object
 * @param replyId - Optional reply ID for conversation continuity
 * @param customSettings - Optional custom settings to include with the message
 * @returns The request options ready to be used with startStream
 */
export const createChatStreamRequest = (message, auth, replyId, customSettings) => {
    const headers = {};
    if (auth.authToken) {
        headers['Authorization'] = `Bearer ${auth.authToken}`;
    }
    if (auth.sessionId) {
        headers['Session-ID'] = auth.sessionId;
    }
    const body = { message };
    if (replyId && replyId !== '') {
        body.reply_id = replyId;
    }
    if (customSettings && Object.keys(customSettings).length > 0) {
        body.custom_settings = customSettings;
    }
    return { headers, body };
};
/**
 * Sends feedback for a message
 * @param threadId - The ID of the thread the message belongs to
 * @param isPositive - Whether the feedback is positive (1) or negative (0)
 * @param auth - The authentication info object
 * @returns A promise that resolves to an object containing the success status and an error message if the feedback fails
 */
export const sendFeedback = (threadId, isPositive, auth, baseUrl) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        if (!baseUrl) {
            return { success: false, error: 'Base URL is required for feedback' };
        }
        const rootUrl = getRootUrl(baseUrl);
        const headers = {
            'Content-Type': 'application/json',
        };
        if (auth === null || auth === void 0 ? void 0 : auth.authToken) {
            headers['Authorization'] = `Bearer ${auth.authToken}`;
        }
        if (auth === null || auth === void 0 ? void 0 : auth.sessionId) {
            headers['Session-ID'] = auth.sessionId;
        }
        const response = yield fetch(`${rootUrl}/feedback`, {
            method: 'POST',
            headers,
            body: JSON.stringify({
                thread_id: threadId,
                is_positive: isPositive ? 1 : 0,
            }),
        });
        if (response.status === 204) {
            return { success: true };
        }
        else {
            return { success: false, error: `HTTP ${response.status}` };
        }
    }
    catch (error) {
        return {
            success: false,
            error: error instanceof Error ? error.message : 'Unknown error'
        };
    }
});
